import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { generateVariantString } from '~/utils';
import { checkIfProductIsGift } from '~/helpers/checkIfProductIsGift';
import { useCart } from '~/composables/useCart';
import { LEGACY_GIFT_CARD_FREE_SHIPPING, LEGACY_GIFT_CARDS_KEY } from '~/constants/giftCardsConstants';
import { useCartGetters } from '~/composables/_next/cart/useCartGetters';
import { useLocalization } from '~/composables/_next/useLocalization';
export var useCartPreview = function useCartPreview(inputCart, inputProducts) {
  var _useLocalization = useLocalization(),
    locale = _useLocalization.locale;
  var _useCart = useCart(),
    initialCart = _useCart.cart;
  var _useCartGetters = useCartGetters(),
    getTotals = _useCartGetters.getTotals;
  var cart = computed(function () {
    return inputCart !== null && inputCart !== void 0 ? inputCart : initialCart.value;
  });
  var products = computed(function () {
    var _ref, _cart$value;
    return (_ref = inputProducts !== null && inputProducts !== void 0 ? inputProducts : (_cart$value = cart.value) === null || _cart$value === void 0 ? void 0 : _cart$value.lineItems) !== null && _ref !== void 0 ? _ref : [];
  });
  var totals = computed(function () {
    return getTotals(cart.value);
  });
  var gifts = ref({
    amount: 0,
    products: [],
    giftDiscountsNamesWithCode: [],
    giftsDiscountNamesWithoutCode: []
  });
  var getDiscountData = function getDiscountData(id) {
    var _cart$value2;
    if (!((_cart$value2 = cart.value) !== null && _cart$value2 !== void 0 && _cart$value2.discountCodes)) return;
    var code = cart.value.discountCodes.find(function (code) {
      var _code$discountCode, _code$discountCode$ca;
      return (_code$discountCode = code.discountCode) === null || _code$discountCode === void 0 ? void 0 : (_code$discountCode$ca = _code$discountCode.cartDiscounts) === null || _code$discountCode$ca === void 0 ? void 0 : _code$discountCode$ca.some(function (cartDiscount) {
        return (cartDiscount === null || cartDiscount === void 0 ? void 0 : cartDiscount.id) === id;
      });
    });
    return code === null || code === void 0 ? void 0 : code.discountCode;
  };
  var prepareShippingDiscount = function prepareShippingDiscount(discount, requireCode) {
    return {
      name: getProperDiscountName(discount, requireCode),
      code: getProperDiscountCode(discount, requireCode),
      amount: discount.discountedAmount.centAmount,
      currencyCode: discount.discountedAmount.currencyCode
    };
  };
  var findCouponAndAddAmountIfExists = function findCouponAndAddAmountIfExists(productCoupons, includedDiscount, quantity) {
    var discount = includedDiscount.discount,
      discountedAmount = includedDiscount.discountedAmount;
    var coupon = productCoupons.find(function (coupon) {
      return coupon.id === (discount === null || discount === void 0 ? void 0 : discount.id);
    });
    if (coupon) coupon.amount += discountedAmount.centAmount ? discountedAmount.centAmount * quantity : 0;
    return !!coupon;
  };
  var getProperDiscountName = function getProperDiscountName(discount, requireCode) {
    var _discount$discount2;
    if (!discount.discount) return null;
    var _discount$discount = discount.discount,
      key = _discount$discount.key,
      name = _discount$discount.name;
    var discountData = getDiscountData((_discount$discount2 = discount.discount) === null || _discount$discount2 === void 0 ? void 0 : _discount$discount2.id);
    return requireCode ? (discountData === null || discountData === void 0 ? void 0 : discountData.name) || (discountData === null || discountData === void 0 ? void 0 : discountData.code) : key || name;
  };
  var getProperDiscountCode = function getProperDiscountCode(discount, requireCode) {
    var _discount$discount4;
    if (!discount.discount) return null;
    var _discount$discount3 = discount.discount,
      key = _discount$discount3.key,
      name = _discount$discount3.name;
    var discountData = getDiscountData((_discount$discount4 = discount.discount) === null || _discount$discount4 === void 0 ? void 0 : _discount$discount4.id);
    return requireCode ? (discountData === null || discountData === void 0 ? void 0 : discountData.code) || (discountData === null || discountData === void 0 ? void 0 : discountData.name) : key || name;
  };
  var getShippingCoupons = function getShippingCoupons(requireCode) {
    var _cart$value$shippingI, _cart$value3, _cart$value3$shipping;
    var _ref2 = (_cart$value$shippingI = (_cart$value3 = cart.value) === null || _cart$value3 === void 0 ? void 0 : (_cart$value3$shipping = _cart$value3.shippingInfo) === null || _cart$value3$shipping === void 0 ? void 0 : _cart$value3$shipping.discountedPrice) !== null && _cart$value$shippingI !== void 0 ? _cart$value$shippingI : {},
      includedDiscounts = _ref2.includedDiscounts;
    return includedDiscounts ? includedDiscounts.filter(function (_ref3) {
      var discount = _ref3.discount;
      return (discount === null || discount === void 0 ? void 0 : discount.requiresDiscountCode) === requireCode && (discount === null || discount === void 0 ? void 0 : discount.key) !== LEGACY_GIFT_CARD_FREE_SHIPPING;
    }).map(function (discount) {
      return prepareShippingDiscount(discount, requireCode);
    }) : [];
  };
  var allProductGifts = computed(function () {
    gifts.value.amount = 0;
    gifts.value.products = [];
    products.value.forEach(function (product) {
      var productGiftInfo = checkIfProductIsGift(product);
      if (!productGiftInfo) return gifts.value;
      var existingGift = gifts.value.products.find(function (gift) {
        return gift.giftID === (productGiftInfo === null || productGiftInfo === void 0 ? void 0 : productGiftInfo.id);
      });
      if (existingGift) {
        existingGift.products.push(product);
        existingGift.isMultipleDiscount = true;
      } else {
        gifts.value.products.push({
          products: [product],
          giftID: productGiftInfo === null || productGiftInfo === void 0 ? void 0 : productGiftInfo.id,
          isMultipleDiscount: false
        });
        var properGiftsDataSet = productGiftInfo.requiresCode ? gifts.value.giftDiscountsNamesWithCode : gifts.value.giftsDiscountNamesWithoutCode;
        if (!properGiftsDataSet.includes(productGiftInfo.name) && !properGiftsDataSet.includes(productGiftInfo.key)) {
          properGiftsDataSet.push(productGiftInfo.name || productGiftInfo.key);
        }
      }
      if (!productGiftInfo.isProductDiscount) {
        gifts.value.amount += productGiftInfo.amount;
      }
    });
    return gifts.value;
  });
  var shippingCouponsWithoutPromoCode = computed(function () {
    return getShippingCoupons(false);
  });
  var shippingCouponsWithPromoCode = computed(function () {
    return getShippingCoupons(true);
  });
  var discountedSubtotal = computed(function () {
    return totals.value.total;
  });
  var prepareProductDiscount = function prepareProductDiscount(includedDiscount, quantity, currencyCode, requireCode) {
    var _includedDiscount$dis, _includedDiscount$dis2, _includedDiscount$dis3, _getDiscountData, _includedDiscount$dis4;
    return {
      amount: ((_includedDiscount$dis = includedDiscount.discountedAmount) === null || _includedDiscount$dis === void 0 ? void 0 : _includedDiscount$dis.centAmount) === 0 ? 0 : (((_includedDiscount$dis2 = includedDiscount.discountedAmount) === null || _includedDiscount$dis2 === void 0 ? void 0 : _includedDiscount$dis2.centAmount) || 1) * quantity,
      id: (_includedDiscount$dis3 = includedDiscount.discount) === null || _includedDiscount$dis3 === void 0 ? void 0 : _includedDiscount$dis3.id,
      name: getProperDiscountName(includedDiscount, requireCode),
      code: requireCode ? (_getDiscountData = getDiscountData((_includedDiscount$dis4 = includedDiscount.discount) === null || _includedDiscount$dis4 === void 0 ? void 0 : _includedDiscount$dis4.id)) === null || _getDiscountData === void 0 ? void 0 : _getDiscountData.code : null,
      currencyCode: currencyCode
    };
  };
  var priceDecrease = ref(0);
  var productDiscountsForPriceDecrease = computed(function () {
    priceDecrease.value = 0;
    products.value.forEach(function (product) {
      if (product.price.discounted) {
        var giftInfo = checkIfProductIsGift(product);
        if (giftInfo) {
          priceDecrease.value += giftInfo.amount / 100;
          return;
        }
        var productDiscountedAmount = (product.price.value.centAmount - product.price.discounted.value.centAmount) * product.quantity / 100;
        priceDecrease.value += productDiscountedAmount;
      }
    });
    return priceDecrease.value;
  });
  var productCoupons = computed(function () {
    var coupons = {
      withPromoCode: [],
      withoutPromoCode: [],
      giftPromoCodes: [],
      giftWithoutPromoCode: [],
      notAppliedWithPromoCode: [],
      legacyGiftCards: []
    };
    var allProductsDiscounts = [];
    var allDiscountedPricePerQuantity = [];
    products.value.forEach(function (product) {
      if (product.discountedPricePerQuantity) {
        allDiscountedPricePerQuantity.push.apply(allDiscountedPricePerQuantity, _toConsumableArray(product.discountedPricePerQuantity));
      }
    });
    allDiscountedPricePerQuantity.forEach(function (price) {
      var _price$discountedPric;
      if ((_price$discountedPric = price.discountedPrice) !== null && _price$discountedPric !== void 0 && _price$discountedPric.includedDiscounts) {
        allProductsDiscounts.push.apply(allProductsDiscounts, _toConsumableArray(price.discountedPrice.includedDiscounts.map(function (discount) {
          return _objectSpread(_objectSpread({}, discount), {}, {
            price: price
          });
        })));
      }
    });
    allProductsDiscounts.forEach(function (includedDiscount) {
      var _includedDiscount$dis5, _includedDiscount$dis7;
      var requiresDiscountCode = (_includedDiscount$dis5 = includedDiscount.discount) === null || _includedDiscount$dis5 === void 0 ? void 0 : _includedDiscount$dis5.requiresDiscountCode;
      var productGiftInfo = allProductGifts.value.products.find(function (gift) {
        var _includedDiscount$dis6;
        return gift.giftID === ((_includedDiscount$dis6 = includedDiscount.discount) === null || _includedDiscount$dis6 === void 0 ? void 0 : _includedDiscount$dis6.id);
      });
      if (productGiftInfo) {
        var giftInfos = {
          couponInfo: prepareProductDiscount(includedDiscount, includedDiscount.price.quantity, includedDiscount.price.discountedPrice.value.currencyCode, requiresDiscountCode),
          products: [],
          isMultipleDiscount: productGiftInfo.isMultipleDiscount
        };
        productGiftInfo.products.forEach(function (product) {
          var _product$price, _product$price$value, _product$price2, _product$price2$value, _product$variant$imag;
          var currencyCode = ((_product$price = product.price) === null || _product$price === void 0 ? void 0 : (_product$price$value = _product$price.value) === null || _product$price$value === void 0 ? void 0 : _product$price$value.currencyCode) || 'EUR';
          var normalPriceCentAmount = (_product$price2 = product.price) === null || _product$price2 === void 0 ? void 0 : (_product$price2$value = _product$price2.value) === null || _product$price2$value === void 0 ? void 0 : _product$price2$value.centAmount;
          giftInfos.products.push({
            title: product.name,
            price: normalPriceCentAmount,
            discount: {
              price: '0',
              percentage: '0',
              isGift: true
            },
            imgSrc: (_product$variant$imag = product.variant.images[0]) === null || _product$variant$imag === void 0 ? void 0 : _product$variant$imag.url,
            quantity: product.quantity,
            variantString: generateVariantString(product.variant, locale),
            hideAmount: true
          });
        });
        var _properDataSet = requiresDiscountCode ? coupons.giftPromoCodes : coupons.giftWithoutPromoCode;
        var giftPromoCodes = _properDataSet.find(function (gift) {
          var _gift$couponInfo, _giftInfos$couponInfo;
          return ((_gift$couponInfo = gift.couponInfo) === null || _gift$couponInfo === void 0 ? void 0 : _gift$couponInfo.code) === ((_giftInfos$couponInfo = giftInfos.couponInfo) === null || _giftInfos$couponInfo === void 0 ? void 0 : _giftInfos$couponInfo.code);
        });
        if (!giftPromoCodes) {
          _properDataSet.push(giftInfos);
        } else if (!giftPromoCodes.isMultipleDiscount) {
          var _giftPromoCodes$produ;
          (_giftPromoCodes$produ = giftPromoCodes.products).push.apply(_giftPromoCodes$produ, _toConsumableArray(giftInfos.products));
        }
        return;
      }
      var properDataSet = requiresDiscountCode ? coupons.withPromoCode : coupons.withoutPromoCode;
      if ((includedDiscount === null || includedDiscount === void 0 ? void 0 : (_includedDiscount$dis7 = includedDiscount.discount) === null || _includedDiscount$dis7 === void 0 ? void 0 : _includedDiscount$dis7.key) === LEGACY_GIFT_CARDS_KEY) return;
      if (!findCouponAndAddAmountIfExists(properDataSet, includedDiscount, includedDiscount.price.quantity)) {
        properDataSet.push(prepareProductDiscount(includedDiscount, includedDiscount.price.quantity, includedDiscount.price.discountedPrice.value.currencyCode, requiresDiscountCode));
      }
    });
    getNotAppliedCoupons(coupons);
    return coupons;
  });
  var isCodeAppliedInGifts = function isCodeAppliedInGifts(coupons, codeID) {
    return coupons.giftPromoCodes.find(function (code) {
      var _code$couponInfo;
      return code.id === codeID || (code === null || code === void 0 ? void 0 : (_code$couponInfo = code.couponInfo) === null || _code$couponInfo === void 0 ? void 0 : _code$couponInfo.id) === codeID;
    });
  };
  var isCodeAppliedInCodes = function isCodeAppliedInCodes(coupons, codeID) {
    return coupons.withPromoCode.find(function (code) {
      return code.id === codeID;
    });
  };
  var isCodeAppliedInShippingCodes = function isCodeAppliedInShippingCodes(discount) {
    return shippingCouponsWithPromoCode.value.find(function (code) {
      return code.name === discount.discountCode.name && code.code === discount.discountCode.code;
    });
  };
  var getNotAppliedCoupons = function getNotAppliedCoupons(coupons) {
    var _cart$value4;
    if (!((_cart$value4 = cart.value) !== null && _cart$value4 !== void 0 && _cart$value4.discountCodes)) return;
    cart.value.discountCodes.forEach(function (discount) {
      var _discount$discountCod, _discount$discountCod2, _discount$discountCod3, _discount$discountCod4, _discount$discountCod5;
      var codeID = (_discount$discountCod = discount.discountCode.cartDiscounts) === null || _discount$discountCod === void 0 ? void 0 : (_discount$discountCod2 = _discount$discountCod[0]) === null || _discount$discountCod2 === void 0 ? void 0 : _discount$discountCod2.id;
      if ((discount === null || discount === void 0 ? void 0 : (_discount$discountCod3 = discount.discountCode) === null || _discount$discountCod3 === void 0 ? void 0 : (_discount$discountCod4 = _discount$discountCod3.cartDiscounts) === null || _discount$discountCod4 === void 0 ? void 0 : (_discount$discountCod5 = _discount$discountCod4[0]) === null || _discount$discountCod5 === void 0 ? void 0 : _discount$discountCod5.key) === LEGACY_GIFT_CARDS_KEY) {
        coupons.legacyGiftCards.push({
          id: codeID,
          name: discount.discountCode.name || discount.discountCode.code,
          code: discount.discountCode.code
        });
      } else if (!isCodeAppliedInGifts(coupons, codeID) && !isCodeAppliedInCodes(coupons, codeID) && !isCodeAppliedInShippingCodes(discount)) {
        coupons.notAppliedWithPromoCode.push({
          id: codeID,
          name: discount.discountCode.name || discount.discountCode.code,
          code: discount.discountCode.code
        });
      }
    });
  };

  /**
   * Gets the legacy gift card amount.
   * Note: this function can be deleted once legacy gift cards
   * are deprecated.
   *
   * @param      {String}  couponCode  The coupon code
   * @return     {String}  The legacy gift card amount.
   */
  function getLegacyGiftCardAmount(couponCode) {
    var _cart$value5, _cart$value6, _lineAmount$money;
    var answerInNumbers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!Array.isArray((_cart$value5 = cart.value) === null || _cart$value5 === void 0 ? void 0 : _cart$value5.customLineItems)) return '';
    var lineAmount = (_cart$value6 = cart.value) === null || _cart$value6 === void 0 ? void 0 : _cart$value6.customLineItems.find(function (item) {
      return (item === null || item === void 0 ? void 0 : item.slug) === "giftcard-".concat(couponCode);
    });
    if (isNaN(lineAmount === null || lineAmount === void 0 ? void 0 : (_lineAmount$money = lineAmount.money) === null || _lineAmount$money === void 0 ? void 0 : _lineAmount$money.centAmount)) return '';
    if (answerInNumbers) {
      var _lineAmount$money2;
      return (lineAmount === null || lineAmount === void 0 ? void 0 : (_lineAmount$money2 = lineAmount.money) === null || _lineAmount$money2 === void 0 ? void 0 : _lineAmount$money2.centAmount) / 100;
    } else {
      var _lineAmount$money3;
      return (lineAmount === null || lineAmount === void 0 ? void 0 : (_lineAmount$money3 = lineAmount.money) === null || _lineAmount$money3 === void 0 ? void 0 : _lineAmount$money3.centAmount) / 100;
    }
  }
  return {
    shippingCouponsWithoutPromoCode: shippingCouponsWithoutPromoCode,
    shippingCouponsWithPromoCode: shippingCouponsWithPromoCode,
    productDiscountsForPriceDecrease: productDiscountsForPriceDecrease,
    productCoupons: productCoupons,
    allProductGifts: allProductGifts,
    discountedSubtotal: discountedSubtotal,
    getLegacyGiftCardAmount: getLegacyGiftCardAmount
  };
};